import { UserType } from "@/hooks/useUrlParams";

export enum HomeView {
  ATTENDANCE_SHEETS = "attendance-sheets",
  ACTIVE_CERTIFICATES = "active-certificates",
  PAYMENTS = "payments",
}

export function getHomeView(
  searchParams: URLSearchParams,
  userType: UserType,
): HomeView {
  const raw = searchParams.get("view") || searchParams.get("familyView");

  if (raw === HomeView.PAYMENTS) {
    return HomeView.PAYMENTS;
  }

  if (raw === HomeView.ACTIVE_CERTIFICATES && userType === UserType.FAMILY) {
    return HomeView.ACTIVE_CERTIFICATES;
  }

  return HomeView.ATTENDANCE_SHEETS;
}
